import {createFileRoute, Link, Outlet, useMatches} from '@tanstack/react-router'

import React from "react";
import {useTranslation} from "../../../../utils/helpers";
import {ContentHeader} from "../../../../components/contentHeader";
import {Button} from "@chakra-ui/react";

import {zeroLevelBeforeLoad} from "../../../../utils/collectionListing";
import {findInMatchesData} from "../../../../utils/findInMatchesData";
import {TagCategory} from "../../../../models/tag";
import {XwgFilter} from "../../../../models/xwgSearchQuery";
import {ZeroLevelContext, zeroLevelRouteLoader} from "../../../../utils/collectionListing/zero";
import {RouterContext} from "../../../../models/routerContext";
import {ROUTES} from "../../../../constants";

export const Route = createFileRoute('/_site/cwg/browse')({
    component: CwgBrowseHeader,
    beforeLoad: async ({context}: {context: RouterContext}): Promise<ZeroLevelContext & {isAdvanced: boolean}> => {
        const zero: ZeroLevelContext = await zeroLevelBeforeLoad(context);
        return {
            ...zero,
            isAdvanced: false
        } as ZeroLevelContext & {isAdvanced: boolean};
    },
    loader: zeroLevelRouteLoader,
});

function CwgBrowseHeader() {
    const {t} = useTranslation("browse");
    const ldr = Route.useLoaderData();

    if (!ldr) {
        return <Outlet />
    }

    const {tagCategories} = ldr;
    const matches = useMatches();
    const primaryCategory = findInMatchesData<TagCategory>(matches, "primaryCategory");
    const isAdvanced = findInMatchesData<boolean>(matches, "isAdvanced");
    const filter = findInMatchesData<XwgFilter>(matches, "filter");

    return <>
        <ContentHeader
            title={t("Browse catalogue")}
            toolbarTitle={t("Primary sorting:")}
            toolbarButtons={[
                ...tagCategories.map(category =>
                    <Button
                        size={"sm"}
                        key={category.id}
                        as={Link}
                        from={ROUTES.BROWSE}
                        to={"./$primarySorting/"}
                        params={{
                            primarySorting: `by-${category.id}`
                        }}
                        isActive={primaryCategory?.id === category.id}
                    >
                        {category.name}
                    </Button>
                ),
                <Button
                    key={"advanced"}
                    size={"sm"}
                    as={Link}
                    from={ROUTES.BROWSE}
                    to={"./advanced/$filter"}
                    params={{
                        filter: filter ?? {}
                    }}
                    isActive={isAdvanced}
                >
                    {t("Advanced")}
                </Button>
            ]}
        />
        <Outlet />
    </>
}
